define(
	'NetScore.PDPImageSwatch.PDPImageSwatch'
,   [
		'NetScore.PDPImageSwatch.PDPImageSwatch.View'
	,	'ProductDetails.ImageGallery.View'
	,	'SC.Configuration'
	,	'Utils'
	]
,   function (
		PDPImageSwatchView
	,	ProductDetailsImageGalleryView
	,	Configuration
	,	Utils
	)
{
	'use strict';
	var count=0,length;
	// _.extend(ProductDetailsImageGalleryView.prototype, {
	// 	getContext: function() {
 //        // @class ProductDetails.ImageGallery.View.Context
 //        console.log("ggg",this.images[1]);
 //        console.log("fff",this.images);

 //        return {
 //            // @property {String} imageResizeId
 //            imageResizeId: Utils.getViewportWidth() < 768 ? 'thumbnail' : 'main',
 //            // @property {Array<ImageContainer>} images
 //            images: this.images || [],
 //            // @property {ImageContainer} firstImage
 //            firstImage: this.images[1] || {},
 //            // @property {Boolean} showImages
 //            showImages: this.images.length > 0,
 //            // @property {Boolean} showImageSlider
 //            showImageSlider: this.images.length > 1
 //        };
 //        // @class ProductDetails.ImageGallery.View
 //    }

	// })

	
	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var PDP_info = container.getComponent('PDP');
			// layout.removeChildView('Product.ImageGallery');
			// console.log('Child view removed.');
						
			if(layout)
			{
				layout.addChildView('Product.ImageGallery', function() { 
					return new PDPImageSwatchView({ container: container,PDP_info:PDP_info });
				});
			}

			layout.addToViewContextDefinition('ProductViews.Option.View', 'values', 'object', function values (context)                 
				{
					//console.log('SC.Configuration',SC.CONFIGURATION.PDPimageSwatch.matrixoptionn);
					if(context.cartOptionId==SC.CONFIGURATION.PDPimageSwatch.matrixoptionn)
					{
						var PDP = container.getComponent('PDP');
						// console.log('PDP',PDP);
						var iteminfo= PDP.getItemInfo();
						// console.log('iteminfo',iteminfo);
						var values = context.values;
						var itemimagedetails=iteminfo.item.itemimages_detail;
						// console.log('itemimagedetails',itemimagedetails);
						//console.log('values',values);
						// for(var i=0;i<values.length;i++){
						_.each(values,function(value){
							// console.log("hello",value.label);
							// console.log("hi",itemimagedetails[values.label].urls[0].url);
							if(itemimagedetails[value.label])
							{
								value.isColorTile=false;
								value.image.label="Click to select "+value.label;
								value.image.src=itemimagedetails[value.label].urls[0].url;
								value.image.height=SC.CONFIGURATION.PDPimageSwatch.SwatchHeight;
								value.image.width=SC.CONFIGURATION.PDPimageSwatch.SwatchWidth;
							}
							else
							{
								if(value.color==undefined)
								{
									value.isColorTile=false;
									value.image.label="Click to select "+value.label;
									value.image.src=SC.CONFIGURATION.PDPimageSwatch.SwatchImageNotAvailable;
									value.image.height=SC.CONFIGURATION.PDPimageSwatch.SwatchHeight;
									value.image.width=SC.CONFIGURATION.PDPimageSwatch.SwatchWidth;
									value.imgnotavail=true;
								}
								else
								{
									value.isColorTile=true;
									value.image.label="Click to select "+value.label;
									value.image.height=SC.CONFIGURATION.PDPimageSwatch.SwatchHeight;
									value.image.width=SC.CONFIGURATION.PDPimageSwatch.SwatchWidth;
									value.imgnotavail=false;
								}
								//console.log("hi",values[i]);
							}
							
						});								
						return values;
					}
					else{
						return context.values;
					}
					
				})
			layout.addToViewContextDefinition('ProductDetails.ImageGallery.View', 'values', 'object', function values (context)
			{
				//console.log("context",context);
				if(count == 0)
					{
					 	length=context.images.length;
					 	count++;
				 	}
				//console.log("length",length);
					if(context.images.length == length)
					{
						sessionStorage.setItem('showthumbnail',false);
					}
					else{
						sessionStorage.setItem('showthumbnail',true);
					}
					//context.images = context.images[0];
					context.showImageSlider=false;
					//return images;
					
			})

		}
	};
});
